// extracted by mini-css-extract-plugin
export var cardFigure = "_b-0";
export var cardImage = "_b-2";
export var cardInner = "_b-1";
export var cardLabel = "_b-3";
export var cardPill = "_b-4";
export var cardPillActive = "_b-6";
export var cardPillSelfServe = "_b-7";
export var cardPillText = "_b-5";
export var pillGlow = "_b-8";
export var pillShimmer = "_b-9";